import ActivityInput from "@/pages/(app)/returns/view/components/return-activity/activity-input";
import ActivityList from "@/pages/(app)/returns/view/components/return-activity/activity-list";
import type { ReturnRequestDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Label } from "@babackapp/ui/components/label";

type ReturnRequestActivityProps = {
  returnRequest: ReturnRequestDto;
};

export default function Activity({
  returnRequest,
}: ReturnRequestActivityProps) {
  const t = useTranslation();

  return (
    <div className="mt-6">
      <Label>{t("returnDetail.activity")}</Label>
      <div className={"mt-2 flex flex-col gap-2"}>
        <ActivityInput
          returnRequestId={returnRequest.id}
          shopId={returnRequest.shopId}
        />
        <ActivityList
          activities={returnRequest.logs}
          returnRequestId={returnRequest.id}
        />
      </div>
    </div>
  );
}
